import { render, staticRenderFns } from "./UgiMainSection.vue?vue&type=template&id=1ecb9970&"
import script from "./UgiMainSection.vue?vue&type=script&lang=js&"
export * from "./UgiMainSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports